import { captureCurrentUndoable } from "@/components/pitchCorrection/undo/captureCurrentUndoable";
import { UNDO_GESTURE_WINDOW_MS } from "@/constants/pitchCorrection/undo";
import {
  UndoTransition,
  UndoTransitionInputs,
} from "@/types/defs/pitchCorrection/undo";

// Rewinds the newest gesture off the undo stack: "edit" entries closer together than UNDO_GESTURE_WINDOW_MS are one gesture (a drag pushes one snapshot per mousemove), so undo restores the gesture's starting state. "history" entries (pushed by undo/redo itself) never batch — their timestamps are press times, and a held redo key must stay reversible one press at a time. The displaced current state is captured onto the redo stack. Returns null when there is nothing to undo.
export const computeUndoTransition = ({
  undoStack,
  redoStack,
  currentPitchState,
  currentCircles,
  now,
}: UndoTransitionInputs): UndoTransition | null => {
  const consideredUndoStack = [...undoStack];
  let restored = consideredUndoStack.pop();
  while (
    restored !== undefined &&
    restored.source === "edit" &&
    consideredUndoStack.length > 0 &&
    consideredUndoStack[consideredUndoStack.length - 1].source === "edit" &&
    restored.time.getTime() -
      consideredUndoStack[consideredUndoStack.length - 1].time.getTime() <
      UNDO_GESTURE_WINDOW_MS
  ) {
    restored = consideredUndoStack.pop();
  }
  if (restored === undefined) {
    return null;
  }
  return {
    undoStack: consideredUndoStack,
    redoStack: [
      ...redoStack,
      captureCurrentUndoable({
        restored,
        currentPitchState,
        currentCircles,
        now,
      }),
    ],
    restored,
  };
};
